import React, { useState, useCallback, useEffect, useMemo } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import LeftPanel from './Components/LeftPanel';
import RightPanel from './Components/RightPanel';
import { outerWrapper, heading, container, loadingWrapper, loadingText } from './RecentActivity.style';

import {
    getContractDataById, clearSuccessMsg, getDataModelById, getModelDataDropDown, initiateAction,
    updateDataModelData, getMembersList, clearReduxDataOfCurrentComponent, getModelData,
    getGroupsByMemberId, getNextRespondent, getDataModels, createOpportunity, getAllOpportunities,
    deleteOpportunity, getSingleOpportunity, updateOpportunity, createActionForOpportunity,
    getAllActionsOfOpportunity, getSingleActionOfOpportunity, updateSingleActionOfOpportunity,
    deleteSingleActionOfOpportunity, getDocumentsFromIDsOfOpportunity, uploadAttachmentOpportunity,
    deleteAttachmentsForOpportunity, downloadContractPDFAction, getWorkflowById, getNextTasks,
    executeWorkFlow, executeWorkFlowReject, createTaskForObligations, getAllTaskofobligation,
    getSingleTaskofobligation, initiateworkFlowObligations, changeAssigneeRequest,
    updateSingleTaskofobligation, getFirstStepMembers, acceptWorkFlowObligations,
    deleteTaskofobligation, currentStepMembersForobligation, rejectedWorkFlowObligations,
    addComment, getAuditTrailsData, completedWorkFlowObligations, getContractHierarchys,
    downloadSheet, getSpendDetails, getSpendFilters, globalAuditTrailsData, lastUpdatedDocumentId,
    downloadSheetBundleOpportunity,
} from '../../store/actions';

import { PUBLIC_PATH } from '../../constants';

const RecentActivity = (props) => {
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [sort, setSort] = useState({});
    const [activeTab, setActiveTab] = useState('auditTrails');
    const [currentPage, setCurrentPage] = useState(0);
    const [apiData, setApiData] = useState(null);

    const { data } = props;
    const { chartData, chartUniqueId } = data;
    const {
        selectedDataModel,
        CHIP_STYLES,
        INFO_CARDS_CONFIG,
        RIGHT_PANEL_TABS,
        AVATAR_COLORS,
    } = chartData;

    useEffect(() => {
        props.globalAuditTrailsData({
            dataModelId: selectedDataModel,
            appId: props.appId,
            payload: { sort, page, rowsPerPage },
            dataUniqueId: chartUniqueId + '_recent_activity',
        });
    }, []);

    useEffect(() => {
        if (props.formData?.document?.[chartUniqueId + '_recent_activity']) {
            const obj = props.formData?.document[chartUniqueId + '_recent_activity'] || {};
            setApiData(obj);
        }
    }, [props.formData?.document?.[chartUniqueId + '_recent_activity']]);

    const rows = useMemo(() => {
        if (!apiData?.data) return [];
        return Object.entries(apiData.data)
            .map(([docId, docData]) => {
                const opp = docData?.opportunity;
                if (!opp) return null;
                const currentRespondent =
                    opp?.currentRespondent || opp?.workflow?.currentRespondent?.name || '';
                const status = opp?.status || opp?.workflow?.status || '';
                return {
                    id: docId,
                    title: opp?.opportunityTitle || opp?.opportunityId || docId,
                    actionBy:
                        typeof currentRespondent === 'string'
                            ? currentRespondent
                            : currentRespondent?.name || '',
                    status,
                    opportunity: opp,
                    auditTrails: docData?.auditTrails || [],
                };
            })
            .filter(Boolean);
    }, [apiData]);

    useEffect(() => {
        if (rows.length > 0 && selectedRowId === null) {
            setSelectedRowId(rows[0].id);
        }
    }, [rows]);

    const handleRowClick = useCallback((id) => {
        setSelectedRowId(id);
        setActiveTab('auditTrails');
    }, []);

    const handleRowsPerPageChange = useCallback((e) => {
        setRowsPerPage(Number(e.target.value));
        setCurrentPage(0);
    }, []);

    const paginatedRows = rows.slice(
        currentPage * rowsPerPage,
        (currentPage + 1) * rowsPerPage
    );
    const totalPages = Math.ceil(rows.length / rowsPerPage);

    const selectedEntry = useMemo(
        () => rows.find((r) => r.id === selectedRowId),
        [rows, selectedRowId]
    );

    const opportunity = selectedEntry?.opportunity;
    const auditTrails = selectedEntry?.auditTrails || [];

    const workflowComments = useMemo(
        () => (Array.isArray(opportunity?.workflowComments) ? opportunity.workflowComments : []),
        [opportunity]
    );

    const supplementalInfoComments = useMemo(
        () =>
            Array.isArray(opportunity?.supplementalInformationComments)
                ? opportunity.supplementalInformationComments
                : [],
        [opportunity]
    );

    const isLoading = props.formData?.[chartUniqueId + '_recent_activity_loading'] === true;

    if (isLoading) {
        return (
            <div style={outerWrapper}>
                <div style={heading}>Recent Activity</div>
                <div style={loadingWrapper}>
                    <CircularProgress size={36} style={{ color: '#3f51b5' }} />
                    <span style={loadingText}>Loading recent activity...</span>
                </div>
            </div>
        );
    }

    return (
        <div style={outerWrapper}>
            <div style={heading}>Recent Activity</div>
            <div style={container}>
                <LeftPanel
                    paginatedRows={paginatedRows}
                    selectedRowId={selectedRowId}
                    onRowClick={handleRowClick}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleRowsPerPageChange}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalCount={rows.length}
                    onPageChange={setCurrentPage}
                    chipStyles={CHIP_STYLES}
                    avatarColors={AVATAR_COLORS}
                />
                <RightPanel
                    opportunity={opportunity}
                    auditTrails={auditTrails}
                    workflowComments={workflowComments}
                    supplementalInfoComments={supplementalInfoComments}
                    activeTab={activeTab}
                    onTabChange={setActiveTab}
                    infoCardsConfig={INFO_CARDS_CONFIG}
                    rightPanelTabs={RIGHT_PANEL_TABS}
                    avatarColors={AVATAR_COLORS}
                />
            </div>
        </div>
    );
};

const mapDispatchToProps = {
    getContractDataById,
    updateDataModelData,
    clearSuccessMsg,
    getModelDataDropDown,
    initiateAction,
    getMembersList,
    clearReduxDataOfCurrentComponent,
    getDataModelById,
    getModelData,
    getDataModels,
    getGroupsByMemberId,
    getNextRespondent,
    createOpportunity,
    getAllOpportunities,
    deleteOpportunity,
    getSingleOpportunity,
    updateOpportunity,
    createActionForOpportunity,
    getAllActionsOfOpportunity,
    getSingleActionOfOpportunity,
    updateSingleActionOfOpportunity,
    deleteSingleActionOfOpportunity,
    getDocumentsFromIDsOfOpportunity,
    uploadAttachmentOpportunity,
    deleteAttachmentsForOpportunity,
    downloadContractPDFAction,
    getWorkflowById,
    getNextTasks,
    executeWorkFlow,
    executeWorkFlowReject,
    createTaskForObligations,
    getAllTaskofobligation,
    getSingleTaskofobligation,
    initiateworkFlowObligations,
    changeAssigneeRequest,
    updateSingleTaskofobligation,
    getFirstStepMembers,
    acceptWorkFlowObligations,
    rejectedWorkFlowObligations,
    completedWorkFlowObligations,
    deleteTaskofobligation,
    currentStepMembersForobligation,
    addComment,
    getAuditTrailsData,
    globalAuditTrailsData,
    lastUpdatedDocumentId,
    getContractHierarchys,
    downloadSheet,
    getSpendDetails,
    getSpendFilters,
    downloadSheetBundleOpportunity,
};

const mapStateToProps = (state) => ({
    formData: state.form,
    action: state.action,
    appConfig: state.appConfig.app,
    PUBLIC_PATH: PUBLIC_PATH,
    members: state.appConfig.members,
    dataModels: state.dataModels,
    user: state.user,
    appConfiguration: state.form.document?.appConfig,
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RecentActivity));
